import { render, staticRenderFns } from "./SelectBoxV3.vue?vue&type=template&id=862d22ba&scoped=true&"
import script from "./SelectBoxV3.vue?vue&type=script&lang=ts&"
export * from "./SelectBoxV3.vue?vue&type=script&lang=ts&"
import style0 from "./SelectBoxV3.vue?vue&type=style&index=0&id=862d22ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "862d22ba",
  null
  
)

export default component.exports